import { CommonModule } from '@angular/common'
import { Component, Input, OnInit } from '@angular/core'
import { SimpleDictionary } from '../../models/main/dictionary'
import { DdcDicSComponent } from '../ddc-dic-s/ddc-dic-s.component'

@Component({
  selector: 'ddc-dics',
  templateUrl: './ddc-dics.component.html',
  styleUrl: './ddc-dics.component.scss',
  imports: [DdcDicSComponent, CommonModule],
})
export class DdcDicsComponent implements OnInit {
  @Input('elements') _elements: SimpleDictionary[]
  constructor() {}

  ngOnInit(): void {}
}
